<template>
  <div>
    <div
      class="modal fade"
      :style="{ zIndex: zIndex }"
      :id="id"
      tabindex="-1"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered" :class="cssClass">
        <div class="modal-content" :style="cssStyle">
          <section class="card">
            <header class="card-header">
              <slot name="header">
                <h2 class="card-title">Are you sure?</h2>
              </slot>
              <button
                type="button"
                class="btn-close btn-close-modal"
                @click.prevent="closeModal()"
                aria-label="Close"
              ></button>
            </header>
            <div class="card-body">
              <div class="modal-wrapper">
                <div class="modal-text">
                  <slot name="body">
                    <p class="mb-0">Add content here using slot name body...</p>
                  </slot>
                </div>
              </div>
            </div>

            <footer class="card-footer">
              <slot name="footer">
              </slot>
            </footer>

          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: ['id', 'cssClass', 'zIndex', 'closeModalAction', 'cssStyle'],
  methods: {
    closeModal() {
      this.$emit('close');
      // Check if provided method is actuallu function and not something else
      if (this.closeModalAction && {}.toString.call(this.closeModalAction) === '[object Function]') {
        this.closeModalAction();
      }
      $(`#${this.id}`).modal('hide');
    },
  },
  beforeDestroy() {
    // If the component is torn down while the modal is open (e.g. navigating
    // away with the browser back/forward buttons), Vue Router destroys this
    // component directly without going through Bootstrap's hide() teardown.
    // Bootstrap's backdrop is a separate element appended to <body>, and the
    // 'modal-open' class/inline styles it applies to <body> aren't tied to
    // this component either — none of it gets cleaned up on its own, leaving
    // the page permanently dimmed and unclickable. Force-clean it here,
    // unless some other modal is still legitimately open.
    const otherOpenModal = Array.from(document.querySelectorAll('.modal.show'))
      .some((el) => el !== this.$el && !this.$el.contains(el));

    if (!otherOpenModal) {
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
      document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
    }
  },
};
</script>

<style lang="scss" scoped>
// @import "/vendor/font-awesome/css/all.min.css";
// @import "/vendor/boxicons/css/boxicons.min.css";
// @import "/vendor/magnific-popup/magnific-popup.css";

.btn-close-modal {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>
